import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { formatDate } from '../../../utils/formatters';
import CustomControlCheckbox from '../../elements/formElements/CustomControlCheckbox';
import FormGroup from '../../elements/formElements/FormGroup';
import FormGroupDateRange from '../../elements/formElements/FormGroupDateRange';
import SubmitButton from '../../elements/formElements/SubmitButton';

function PromoCodeEditForm({ action, promoCodeData, errors, isLoading, setIsLoading }) {
    const [promoCode, setPromoCode] = useState({
        max_uses: 0,
        start_date: null,
        end_date: null,
        is_enabled: 0,
    });
    const history = useHistory();

    useEffect(() => {
        if (promoCodeData) {
            setPromoCode({
                ...promoCode,
                max_uses: promoCodeData.max_uses,
                start_date: formatDate(promoCodeData.start_date, true, 'YYYY-MM-DD'),
                end_date: formatDate(promoCodeData.end_date, true, 'YYYY-MM-DD'),
                is_enabled: promoCodeData.is_enabled,
            });
        }
    }, [promoCodeData]);

    function handleSubmit(event) {
        setIsLoading(true);
        event.preventDefault();
        action(promoCode);
    }

    function cancel() {
        history.push('/promo_codes');
    }

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <div className="card-body bg-light">
                <FormGroup
                    type={'text'}
                    field={'max_uses'}
                    value={promoCode.max_uses}
                    label={'Max number of uses of one code'}
                    error={getErrorFor('max_uses')}
                    handleChange={(event) =>
                        setPromoCode({
                            ...promoCode,
                            max_uses: event.target.value,
                        })
                    }
                />
                <FormGroupDateRange
                    startDate={promoCode.start_date ? moment(promoCode.start_date).toDate() : null}
                    endDate={promoCode.end_date ? moment(promoCode.end_date).toDate() : null}
                    label={'Validity dates'}
                    errorStartDate={getErrorFor('start_date')}
                    errorEndDate={getErrorFor('end_date')}
                    handleChange={(dates) =>
                        setPromoCode({
                            ...promoCode,
                            start_date: dates[0],
                            end_date: dates[1],
                        })
                    }
                />
                <CustomControlCheckbox
                    field={'is_enabled'}
                    value={promoCode.is_enabled === 1}
                    label={'Enabled'}
                    error={getErrorFor('is_enabled')}
                    handleChange={(event) => setPromoCode({ ...promoCode, is_enabled: event.target.checked ? 1 : 0 })}
                />
            </div>
            <div className="card-body">
                <button type="button" onClick={cancel} className="btn btn-secondary">
                    Cancel
                </button>
                <SubmitButton label="Save" isLoading={isLoading} />
            </div>
        </form>
    );
}

export default PromoCodeEditForm;
